import { Sync } from '@mui/icons-material';
import { Button, styled } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';

const RefreshBtn = styled(Button)({
  width: '120px',
});

const RefreshButton = (props: ButtonProps) => {
  return (
    <RefreshBtn variant='outlined' startIcon={<Sync />} {...props}>
      Refresh
    </RefreshBtn>
  );
};

export default RefreshButton;
